module.exports = __webpack_public_path__ + "img/toggle-off.9b6b33d6.svg";